import {
  APILibraryVertical,
  type APILibraryVerticalResponseType,
  type IAPILibraryVertical,
} from "@/core/data_sources/models/APILibraryVertical";
import { State } from "@/core/data_sources/store/state";
export type LibraryVerticalsStateType = {
  list: IAPILibraryVertical[];
};
export class LibraryVerticalsState extends State<LibraryVerticalsStateType> {
  constructor() {
    super({ list: [] });
  }

  setVerticals(verticals: APILibraryVerticalResponseType[]) {
    this._observable.next({
      list: verticals.map((v) => new APILibraryVertical(v)),
    });
  }
  clear(): void {
    this._observable.next({ list: [] });
  }
}
